import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { UPDATE_ORDER } from "../order.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateOrderInput } from "../../../__generated__/globalTypes";
import {
  UpdateOrderMutation,
  UpdateOrderMutationVariables,
} from "../../../__generated__/UpdateOrderMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateOrder = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateOrderInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateOrderMutation,
    UpdateOrderMutationVariables
  >(UPDATE_ORDER, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateOrder?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateOrder?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
